if (!customElements.get('testimonials-carousel')) {
	class TestiomialsCarousel extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				imagesTrack: '.carousel__track',
				descriptionSlidesWrapper: '.carousel__descriptions',
				descriptionSlide: '.carousel__descriptions .content',
				carouselTrigger: '.carousel__buttons .button-icon',
				descriptionVisible: '.content--visible',
				contentContainer: '.carousel__descriptions .content',
				mainImage: '.carousel__track .track__slide--main',
				lastImage: '.carousel__track .track__slide:last-child',
				content: '.content',
				currentPaginationSpan: '.carousel__pagination .pagination__current',
				imagesNotLoaded: '.track__slide img',
				trackSlide: '.track__slide',
			};

			this.elements = {
				imagesTrack: this.querySelector(this.selectors.imagesTrack),
				descriptionSlidesWrapper: this.querySelector(this.selectors.descriptionSlidesWrapper),
				carouselTrigger: this.querySelector(this.selectors.carouselTrigger),
				descriptionSlide: this.querySelectorAll(this.selectors.descriptionSlide),
				contentContainer: this.querySelector(this.selectors.contentContainer),
				currentPaginationSpan: this.querySelector(this.selectors.currentPaginationSpan),
			};

			this.classes = {
				trackSlide: 'track__slide',
				contentVisible: 'content--visible',
				mainImage: 'track__slide--main',
				disableDrag: 'carousel__descriptions--disable-drag',
				blurImage: 'slide__image--blur',
				shrink: 'track__slide--shrink',
			};

			this.drag = false;
			this.isScrolling = false;
			this.touchEventMovement = {};
			this.currentIndexToDisplay = 1;
			this.totalSliders = this.elements.descriptionSlide.length;

			this.init();
		}

		init() {
			this.showButton();
			this.elements.carouselTrigger.addEventListener('click', (e) => {
				if (this.isScrolling === true) return;

				this.isScrolling = true;
				this.elements.carouselTrigger.disabled = true;
				this.currentIndexToDisplay = this.currentIndexToDisplay + 1;
				this.changeUI();
			});

			this.elements.descriptionSlidesWrapper.addEventListener(
				'touchstart',
				(e) => {
					this.drag = false;
					this.touchEventMovement = e.targetTouches[0];
				},
				{ passive: true }
			);

			this.elements.descriptionSlidesWrapper.addEventListener('touchmove', () => (this.drag = true), {
				passive: true,
			});

			this.elements.descriptionSlidesWrapper.addEventListener(
				'touchend',
				(e) => {
					if (this.isScrolling === true) return;

					if (this.drag) {
						const touchStart = this.touchEventMovement.pageX;
						const touchend = e.changedTouches[0].pageX;

						if (Math.abs(touchend - touchStart) < 120) return;

						this.elements.descriptionSlidesWrapper.classList.add(this.classes.disableDrag);
						if (this.touchEventMovement.pageX < e.changedTouches[0].pageX) {
							this.isScrolling = true;
							this.elements.carouselTrigger.disabled = true;
							const slideIndex =
								this.currentIndexToDisplay === 1 ? this.totalSliders : this.currentIndexToDisplay - 1;

							if (slideIndex === this.currentIndexToDisplay) return;

							const difference =
								slideIndex < this.currentIndexToDisplay
									? Math.abs(this.totalSliders - this.currentIndexToDisplay + slideIndex)
									: Math.abs(slideIndex - this.currentIndexToDisplay);

							if (difference > 1) {
								for (let i = 1; i <= difference; i++) {
									this.currentIndexToDisplay =
										this.currentIndexToDisplay === this.totalSliders
											? 1
											: this.currentIndexToDisplay + 1;
									this.changeUI();
								}
							} else {
								this.currentIndexToDisplay = slideIndex;
								this.changeUI();
							}
						} else {
							this.isScrolling = true;
							this.elements.carouselTrigger.disabled = true;
							this.currentIndexToDisplay =
								this.currentIndexToDisplay === this.titalSliders ? 1 : this.currentIndexToDisplay + 1;
							this.changeUI();
						}
					} else {
						this.touchEventMovement = {};
					}
				},
				{ passive: true }
			);

			this.addEventListener('click', (e) => {
				if (
					e.target.classList.contains(this.classes.trackSlide) ||
					e.target.closest(this.selectors.trackSlide)
				) {
					const slide = e.target.closest(this.selectors.trackSlide);
					const slideIndex = parseInt(slide.dataset.slideIndex);
					if (slideIndex === this.currentIndexToDisplay) return;

					const difference =
						slideIndex < this.currentIndexToDisplay
							? Math.abs(this.totalSliders - this.currentIndexToDisplay + slideIndex)
							: Math.abs(slideIndex - this.currentIndexToDisplay);

					if (difference > 1) {
						for (let i = 1; i <= difference; i++) {
							this.currentIndexToDisplay =
								this.currentIndexToDisplay === this.totalSliders ? 1 : this.currentIndexToDisplay + 1;
							this.changeUI();
						}
					} else {
						this.currentIndexToDisplay = slideIndex;
						this.changeUI();
					}
				}
			});
		}

		changeUI() {
			const currentSlide = this.elements.descriptionSlidesWrapper.querySelector(
				this.selectors.descriptionVisible
			);
			const currentImage = this.elements.imagesTrack.querySelector(this.selectors.mainImage);

			let nextSlide = this.elements.descriptionSlidesWrapper.querySelector(
				`[data-slide-index="${this.currentIndexToDisplay}"]`
			);
			let nextImage = this.elements.imagesTrack.querySelector(
				`[data-slide-index="${this.currentIndexToDisplay}"]`
			);

			if (!nextSlide) {
				this.currentIndexToDisplay = 1;
				nextSlide = this.elements.descriptionSlidesWrapper.querySelector(
					`[data-slide-index="${this.currentIndexToDisplay}"]`
				);
			}

			if (!nextImage) {
				nextImage = this.elements.imagesTrack.querySelector(
					`[data-slide-index="${this.currentIndexToDisplay}"]`
				);
			}

			nextSlide.parentElement
				.querySelectorAll(this.selectors.descriptionSlide)
				.forEach((element) => element.classList.remove(this.classes.contentVisible));
			nextSlide.parentElement.prepend(nextSlide);
			nextSlide.classList.add(this.classes.contentVisible);

			currentImage.classList.add(this.classes.shrink);
			nextImage.classList.add(this.classes.mainImage);
			currentImage.classList.remove(this.classes.mainImage);

			nextImage.parentElement.append(currentImage);
			currentImage.classList.remove(this.classes.shrink);

			this.elements.currentPaginationSpan.textContent = this.currentIndexToDisplay;
			this.enableButton();
		}

		enableButton() {
			setTimeout(() => {
				this.isScrolling = false;
				this.elements.carouselTrigger.disabled = false;
				this.elements.descriptionSlidesWrapper.classList.remove(this.classes.disableDrag);
			}, 500);
		}

		showButton() {
			if (this.elements.descriptionSlide.length <= 1) {
				this.elements.carouselTrigger.style.display = 'none';

				return;
			}
		}
	}

	customElements.define('testimonials-carousel', TestiomialsCarousel);
}
